/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-external-order-shipment.reducer';

export const PharmacyExternalOrderShipmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyExternalOrderShipmentEntity = useAppSelector(state => state.pharmacyExternalOrderShipment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyExternalOrderShipmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.detail.title">PharmacyExternalOrderShipment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.id}</dd>
          <dt>
            <span id="saleBillId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.saleBillId">Sale Bill Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.saleBillId}</dd>
          <dt>
            <span id="purchaseBillId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.purchaseBillId">Purchase Bill Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.purchaseBillId}</dd>
          <dt>
            <span id="refundBillId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.refundBillId">Refund Bill Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.refundBillId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.timestampEntry}</dd>
          <dt>
            <span id="supplierId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.supplierId">Supplier Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.supplierId}</dd>
          <dt>
            <span id="supplierIdType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.supplierIdType">Supplier Id Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.supplierIdType}</dd>
          <dt>
            <span id="consumerId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consumerId">Consumer Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.consumerId}</dd>
          <dt>
            <span id="consumerType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consumerType">Consumer Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.consumerType}</dd>
          <dt>
            <span id="shipmentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.shipmentStatus">Shipment Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.shipmentStatus}</dd>
          <dt>
            <span id="consignmentNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.consignmentNumber">Consignment Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.consignmentNumber}</dd>
          <dt>
            <span id="carrierDetails">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.carrierDetails">Carrier Details</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.carrierDetails}</dd>
          <dt>
            <span id="internalShipmentNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.internalShipmentNumber">
                Internal Shipment Number
              </Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.internalShipmentNumber}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.modifiedByType}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.billNumber">Bill Number</Translate>
            </span>
            <UncontrolledTooltip target="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.billNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.billNumber}</dd>
          <dt>
            <span id="excludeTax">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.excludeTax">Exclude Tax</Translate>
            </span>
            <UncontrolledTooltip target="excludeTax">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.excludeTax" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.excludeTax ? 'true' : 'false'}</dd>
          <dt>
            <span id="portCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.portCode">Port Code</Translate>
            </span>
            <UncontrolledTooltip target="portCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.help.portCode" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.portCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.order">Order</Translate>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.order ? pharmacyExternalOrderShipmentEntity.order.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipment.exportType">Export Type</Translate>
          </dt>
          <dd>{pharmacyExternalOrderShipmentEntity.exportType ? pharmacyExternalOrderShipmentEntity.exportType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-external-order-shipment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-external-order-shipment/${pharmacyExternalOrderShipmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyExternalOrderShipmentDetail;
